import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
    signal,
} from '@angular/core';
import { ReverseThemeDirective } from '@interacta-shared/data-access-theme';
import { IconButtonComponent, LoadMoreComponent } from '@interacta-shared/ui';
import { ToastNotificationGroup } from '@interacta-shared/util-common';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastNotificationGroupComponent } from '../toast-notification-group/toast-notification-group.component';

@Component({
    imports: [
        IconButtonComponent,
        LoadMoreComponent,
        ReverseThemeDirective,
        ToastNotificationGroupComponent,
        TranslatePipe,
    ],
    selector: 'interacta-toast-notification-panel',
    templateUrl: './toast-notification-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastNotificationPanelComponent {
    readonly groups = input.required<ToastNotificationGroup[]>();
    readonly expanded = input.required<boolean>();
    readonly closePanel = output<void>();
    readonly expandPanel = output<void>();

    protected readonly collapsedOverflow = signal(false);

    protected readonly showExpandButton = computed(
        (): boolean =>
            !this.expanded() &&
            (this.collapsedOverflow() ||
                this.groups().length > 1 ||
                (this.groups()[0]?.messages.length ?? 0) > 1),
    );
}
